export class EmailJSResponseStatus {
    constructor(httpResponse) {
        this.status = httpResponse.status;
        this.text = httpResponse.responseText;
    }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@emailjs/browser/es/models/EmailJSResponseStatus.js
// module id = 531
// module chunks = 0